export default __webpack_public_path__ + "static/media/Ramp1.fc3b59c8.png";